import importBtn from '../../images/docs/main-menu-import-edit.png';
import step1Upload from '../../images/docs/step1-upload-edit.png';
import step1Dropdown from '../../images/docs/step1-dropdown-edit.png';
import step2Upload from '../../images/docs/step2-layout-edit.png';
import exampleError from '../../images/docs/example-error.png';
import importTop from '../../images/docs/import-top.png';
import valStatView from '../../images/docs/val-stat-view.png';

export const meta = {
  slug: 'generare-intrastat',
  title: 'Generare Intrastat',
  description: 'Importul fișierului Excel, prelucrarea datelor și generarea declarației Intrastat XML.',
  icon: 'file-code',
  order: 8,
  related: ['machete', 'firme'],
};

export const images = { importBtn, step1Upload, step1Dropdown, step2Upload, exampleError, importTop, valStatView };

export const content = `
## Generare Intrastat

Pentru a verifica orice informație legată de generarea declarațiilor intrastat trebuie să fiți autentificat.

### 1. Importarea fișierului Excel

Pentru generarea fișierului Intrastat prin platforma Programintrastat.ro trebuie încărcat fișierul Excel cu datele necesare. Pentru a face asta va trebui intrat în meniul "Importă Excel" <span class="dot">1</span>

::image[importBtn]{alt="Butonul principal generare Intrastat"}

Ca prim pas va trebui încărcat fișierul local făcând click pe butonul "+" <span class="dot">2</span>

::image[step1Upload]{alt="Butonul importare Excel"}

Odată ce fișierul este importat, va trebui aleasă fișa de lucru (sheet) din meniu <span class="dot">3</span>

::image[step1Dropdown]{alt="Butonul alegere sheet"}

La pasul 2 se vor selecta:

- Macheta corespunzătoare <span class="dot">4</span>
- Anul corespunzător declarației <span class="dot">5</span>
- Luna corespunzătoare declarației <span class="dot">6</span>

::image[step2Upload]{alt="Alegere machetă la import Excel"}

În pasul 3 veți fi informat ce firmă este aleasă pentru declarația de intrastat. Dacă sunteți declaranți terți veți putea selecta opțiunea de declarație terță și să alegeți firma pentru care doriți să generați declarația intrastat.

În pasul 4 (ultimul) veți vedea un rezumat al generării, pentru a vă asigura că toate datele introduse sunt în regulă.

<p class="warn">În cazul în care aveți probleme cu o machetă la importarea fișierului Excel, încercați să ștergeți macheta folosită și să o recreați folosind ca referință fișierul Excel pe care doriți să-l încărcați. Nu uitați să salvați fișierul Excel după fiecare modificare făcută local. Programul nu poate vedea modificările dacă fișierul nu este salvat înainte de a fi încărcat. Recomandăm închiderea fișierului înainte de a îl încărca în program, astfel veți fi siguri că fișierul este salvat cu ultimele modificări.</p>

### 2. Prelucrarea, generarea și verificarea fișierului Excel

Fișierul Excel a fost importat în program. La pasul 4 din meniul de importare, după ce ați verificat ca datele să fie valide, putem apăsa butonul "ÎNCARCĂ". Fișierul va fi încărcat, acest proces poate dura de la câteva secunde la peste un minut, depinzând de dimensiunea fișierului.

Fiți atenți la notificările generate de program din colțul de dreapta sus. Odată încărcat, veți fi întâmpinați de meniul de prelucrare și generare al fișierului. De aici vom putea vedea perioada pentru care declarația intrastat va fi generată, tipul declarației ("Livrări" sau "Achiziții") și firma pentru care este realizat. În cazul firmelor terțe, aici vor apărea ambele firme.

În cazul în care există erori în fișier, acestea vor fi evidențiate cu roșu. Datele din fișier pot fi modificate direct în program, astfel că erorile pot fi rezolvate direct.

După cum se poate observa în această imagine, eroarea este la "Cod Vamal". Căsuța este evidențiată cu roșu, iar "Nr." este și el evidențiat. Dând click pe "Nr." ne va afișa toate coloanele care au erori de pe acest rând. Coloanele cu erori se pot modifica direct în tabel, iar programul va verifica modificarea în timp real. Dacă valoarea introdusă va fi validă, evidențierea cu roșu va fi dezactivată.

<p class="warn">Nu toate coloanele vor fi verificate automat după ce modificați valoarea. Coloane precum Valoare VAT vor trebui validate manual. Dacă aveți dubii în privința unor valori considerate "corecte" verificați de câte ori este nevoie. Programul poate evidenția valori greșite și dacă macheta este greșită. De ex. dacă programul crede că în coloana X se va afla codul vamal, iar de fapt în acea coloană este valoarea fiscală, atunci va evidenția toată coloana cu roșu. Este important să verificați validitatea machetei, dacă ordinea coloanelor din fișierul excel se schimbă, recreați macheta de la 0 pentru a evita orice eroare de genul acesta. În cazul problemelor cu macheta la importarea fișierului, ștergeți și recreați macheta de la 0.</p>

Meniul din partea de sus a paginii de generare constă în mai multe butoane cu diferite funcționalități. Pentru a afla mai multe despre fiecare, țineți mouse-ul deasupra butonului respectiv, iar un meniu informativ va apărea.

Înainte să intrăm în detalii legate de tabelul de editare al fișierului importat și funcționalitățile acestuia, vom afla detalii legate de butoanele din partea de sus a tabelului:

::image[importTop]{alt="Vizualizare butoane superioare import"}

După cum se poate vedea în imaginea de mai sus, avem următoarele butoane:

#### Calcul valoare statistică

Această funcție poate fi activată pentru a calcula valoarea statistică automat. Odată ce este activată funcția, veți putea apăsa butonul albastru de jos cu textul "Calcul val stat" și veți fi întâmpinat de această fereastră:

::image[valStatView]{alt="Fereastra calcul valoare statistică"}

Programul va identifica toate valorile identice ca și câmpuri din acest tabel și le va grupa. Semnul va apărea ca "MINUS" sau "PLUS", acesta este setat automat de către program în funcție de criteriile din tabel, însă poate fi modificat cu ușurință dând click pe acesta. Procentul trebuie pus manual, acesta este 0 ca valoare inițială. Odată ce ați completat procentul și ați verificat ca semnul să fie valid, puteți face click pe "Calculează", iar programul va face toată treaba. În câteva secunde veți avea rezultatul într-o coloană nouă.

#### Declarație revizuită

Dacă selectați această opțiune, declarația Intrastat generată va fi marcată ca și revizuită.

#### XML detaliat

Această opțiune este strict pentru cei interesați de generarea unui fișier XML în care articolele nu vor fi grupate, așa cum sunt în mod normal la generarea unui fișier XML pentru declarația INTRASTAT.

#### Afișează doar erori

Această funcție este foarte utilă, deoarece vă permite să vizualizați exact unde se află erorile din fișierul importat și astfel să puteți corecta mai ușor. Vă recomandăm să bifați această opțiune înainte de generarea finală a fișierului, deoarece puteți identifica dacă există greșeli pe care le-ați omis.

#### Afișează doar necesare

Această funcție poate fi utilă dacă aveți multe coloane în tabelul importat. Dacă este activată, veți putea să lucrați doar pe coloanele necesare pentru declarația Intrastat, iar celelalte coloane vor fi ascunse. La fel ca orice altă funcție, o puteți dezactiva oricând și coloanele ascunse vor reapărea.

#### Lățime întreagă tabel

Dacă selectați această funcție coloanele din tabel vor avea o lățime mai mare pentru a permite o vizibilitate mai bună a datelor. Această funcție este recomandată în combinație cu "Afișează doar necesare".

#### Generare

Acest buton va porni generarea fișierului XML pentru declarația Intrastat. Dacă îl veți apăsa nu veți folosi din liniile disponibile din abonament. Întâi vă va apărea o fereastră în care va trebui să confirmați detaliile legate de declarația Intrastat (Persoană de contact, poziție, etc.) și veți fi informat cu privire la câte linii din abonament veți folosi și câte veți mai avea disponibile. Important: Odată ce apăsați butonul, așteptați ca încărcarea să se finalizeze înainte de a apăsa altceva.

#### Verificare VAT

Acest buton va începe procesul de verificare al codurilor VAT din tabel (dacă sunt prezente). Procesul poate dura câteva minute.

<p class="warn">Odată ce apăsați butonul, așteptați ca încărcarea să se finalizeze înainte de a apăsa altceva.</p>

#### Calcul val stat

Acest buton va fi activ doar în cazul în care ați bifat "Calcul valoare statistică" și vă va permite calculul automat a valorii statistice.

#### Exportă excel

Această funcție vă permite descărcarea în format Excel a tabelului afișat. Este util în cazul în care ați făcut modificări sau ați corectat erori în tabel, astfel puteți avea o copie locală corectă pe care o veți putea importa de fiecare dată, fără a mai avea probleme.

#### Exportă erori

Această funcție va exporta doar erorile din tabel în format excel.

---

În tabel veți avea următoarele funcționalități:

- Număr pentru fiecare rând.
- Validare a codului vamal cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Validare a condiției de livrare cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Validare a modului de transport cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Validare a țării de origine cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Validare a țării de expediere cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Validare a naturii tranzacției cu posibilitatea de a căuta codul necesar într-o listă care cuprinde toate codurile disponibile. Veți putea filtra acea listă prin denumire și cod.
- Cod UMS și valoare UMS generate automat în funcție de condiția de livrare și a cantității. <p class="warn">Pentru a putea genera automat valoare UMS este nevoie să treceți în machetă locația cantității în tabel. Fără aceasta, valoarea UMS nu poate fi generată automat.</p>
- Verificare în timp real a modificărilor din tabel. Toate datele sunt verificate pe cât posibil în cel mai scurt timp. Date precum validarea valorilor VAT trebuiesc validate separat, dând click pe butonul necesar.
- Posibilitatea de a edita manual fiecare celulă din tabel, și apoi de a salva tabelul în format Excel pentru a îl folosi ulterior.

Cu aceste informații puteți genera cu ușurință o declarație Intrastat validă. În cazul în care aveți întrebări sau nelămuriri verificați secțiunea [Întrebări frecvente](/docs/faq). Dacă nu găsiți ceea ce căutați, ne puteți contacta prin formularul de contact de pe platformă sau direct la adresa [programintrastat@gmail.com](mailto:programintrastat@gmail.com).

<p class="warn">Valorile VAT vor trebui să fie în format "BG123456" pentru a fi verificate. Formatul "BG 123456" sau "BG_123456" va fi invalid.</p>
`;
